import React, { Component } from 'react';
import { Container, Card, Row, Col, Button, Badge, Modal, Form, Spinner, Image } from 'react-bootstrap';
import { t } from '../helpers/translation_helper';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faEdit, faHomeUser, faListOl, faPencil, faPlus, faSave, faSearch, faTrashCan, faXmark, faEllipsisV, faTrashAlt, faHeart } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from 'react-select'
import { Chance } from 'chance';
import { Link, NavLink } from 'react-router-dom';
import { getExtension, trimThisDown } from '../helpers/general_helpers';
import { faThumbsDown, faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import { AmericanSilver, Argent, Black, Concrete, CyanProcess, White } from './brand_colors_helper';
import GetIcon from './icon_helper';
const chance = new Chance();

const apiURL = process.env.REACT_APP_API_URL;
const portalURL = process.env.REACT_APP_PORTAL_URL;
class ExamsCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            actionDDL: false,
            cardWidth: '25'
        }
    }

    componentDidMount() {
        if (this.props?.cardWidth) {
            this.setState({ cardWidth: this.props?.cardWidth })
        } else {
            this.resize()
            window.addEventListener('resize', this.resize)
        }
    }
    resize = () => {
        //  1536 739
        //  1920 955
        let WIDTH = window.innerWidth
        let HEIGHT = window.innerHeight
        if (WIDTH > 1600) {
            if (this.state.cardWidth != '20') {
                this.setState({ cardWidth: '20' })
            }
        } else {
            if (this.state.cardWidth != '25') {
                this.setState({ cardWidth: '25' })
            }
        }
    }


    render() {
        let { actionDDL } = this.state
        // let linkTo = ''
        // let linkToStates = {}

        // let cardImage = require('../assets/images/noimage.png')
        // let name = 'Name Name Name'
        // let code = 'CODE'
        // let text1 = 'Name2'
        // let text2 = 'Name3'
        // let description = 'Create consistent cross-browser and cross-device checkboxes and radios with our completely rewritten checks component.'
        // let status = 1
        // let actions = [
        //     { name: 'Edit', iconName: faEdit, iconColor: Black, onClick: () => { } },
        //     { name: 'Delete', iconName: faTrashAlt, iconColor: Black, onClick: () => { } }
        // ]
        // let extraTexts = [
        //     { type: 'url', name: 'URL', value: 'www.google.com', iconName: null, image: require('../assets/images/add-button-small.png'), iconColor: Black, onClick: () => { } },
        //     { type: 'text', name: 'TOPIC', value: 'Some topic Name', icon: null, image: require('../assets/images/hyperlink.png'), iconColor: Black, onClick: () => { } }
        // ]



        if (!this.props.data) {
            return null
        }
        let { allData, linkTo, linkToStates, cardImage, name, code, text1, text2, actions, description, extraTexts, status, onClick } = this.props.data

        // boxShadow: '-1px 2px 16px 2px rgba(0,0,0,0.1)',
        return (<div className='d-flex flex-column justify-content-between' key={this.props.key} style={{ width: 'calc(' + this.state.cardWidth + '% - 20px)', backgroundColor: White, borderRadius: 20, margin: 10, position: 'relative', padding: 0, fontSize: 12, border: 'solid 1px ' + Concrete }}>
            <div style={{ padding: '1rem', }}>
                {cardImage &&
                    <Image src={cardImage} style={{ objectFit: 'cover', width: '100%', height: '9.5rem', backgroundColor: White, borderRadius: '1rem' }} />
                }
                <div className='d-flex justify-content-between'>
                    <div>
                        {code && <div style={{ fontSize: '0.9rem', color: Argent }}>{code}</div>}
                        <div className='d-flex flex-row align-items-start'>
                            <div style={{ fontSize: 14, fontWeight: '600' }}>
                                {name}
                            </div>
                            {allData.acs_name && <div style={{ backgroundColor: CyanProcess, color: White, padding: '2px 4px', borderRadius: 5, fontSize: 11 }} className='d-flex flex-row align-items-center ms-2'>
                                {allData.acs_name}
                            </div>}
                        </div>
                        {text1 &&
                            <div>
                                {text1}
                            </div>
                        }
                        {text2 &&
                            <div>
                                {text2}
                            </div>
                        }
                    </div>
                    {(status == 1 || status == 0)
                        ? <div>
                            <Badge className='me-2' bg={status == 1 ? 'success' : 'danger'}> {status == 1 ? t('Active') : t('Inactive')} </Badge>
                        </div>
                        : (status) && <div>
                            <Badge className='me-2' bg={status.bg}> {status.name} </Badge>
                        </div>
                    }
                </div>
                {(description && description != 'null') && <div className='mt-2'>{trimThisDown(description, 60)}</div>}
            </div>
            <div className='d-flex flex-column'>
                {extraTexts && extraTexts.length > 0 &&
                    <div className='mb-1'>
                        {extraTexts.map((v, i) => {
                            return <div className='d-flex flex-row align-items-center cursor-pointer mb-1 mx-3' style={{ borderRadius: '0.5rem', color: v.textColor }} onClick={v.onClick}>
                                {v.image && <Image src={v.image} style={{ width: '1rem', height: '1rem' }} />}
                                {v.iconName && <GetIcon icon={v.iconName} />}
                                {v.text && <div className='ms-1'>{v.text}</div>}
                            </div>
                        })}
                    </div>
                }
                {actions && actions.length > 0 &&
                    actions.map((v, i) => {
                        return (<Link to={v.linkTo} state={v.linkToStates} onClick={v.onClick} style={{ textDecoration: 'none' }}>
                            <div key={i} className='d-flex flex-row align-items-center justify-content-center cursor-pointer p-2 mb-2 mx-3' style={{ borderRadius: '0.5rem', backgroundColor: v.backgroundColor, color: v.textColor }}  >
                                {v.image && <Image title={t(v.name)} src={v.image} style={{ width: '1rem', height: '1rem' }} />}
                                {v.iconName && <GetIcon icon={v.iconName} />}
                                {v.text && <div className='ms-1'>{v.text}</div>}
                            </div>
                        </Link>)
                    })
                }
            </div>
        </div>);
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    defaultLanguage: state.language.defaultLanguage,
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps())(ExamsCard);
